// extracted by mini-css-extract-plugin
export var aLogo = "wa";
export var lHeader = "xa";
export var lHeader__inner = "ya";
export var animationMarquee = "za";